import type { Document } from '@contentful/rich-text-types';

export const accordionContentType = 'questionComponent';

export interface ParseAccordionEmbeddedEntryArgs {
	fields: unknown;
	renderRichText: (document: Document) => string;
}

export function parseAccordionEmbeddedEntry(
	args: ParseAccordionEmbeddedEntryArgs,
): string | undefined {
	const { fields, renderRichText } = args;
	const accordionFields = fields as
		| { questionTitleExternal?: string; anchorId?: string; answer?: Document }
		| undefined;
	if (!accordionFields?.questionTitleExternal || accordionFields.answer?.nodeType !== 'document') {
		return undefined;
	}

	const { questionTitleExternal, anchorId, answer } = accordionFields;
	const props = { title: questionTitleExternal, anchorId, content: renderRichText(answer) };
	return `<div data-embedded-question="${encodeURIComponent(JSON.stringify(props))}"></div>`;
}
